const QuizAdminViewEnum = {
    ADMIN_LANDING: 0,
    NEW_QUIZ: 1,
    EDITING_QUIZ: 2,
    QUIZ_OVERVIEW: 3,
    LOADING: 4,
};
Object.freeze(QuizAdminViewEnum);
export default QuizAdminViewEnum;